export default __webpack_public_path__ + "static/media/twitter_logo.d386ccd6.svg";